// Logica para manejo de prestadores

import { getPrimerosProximosTurnos } from "../../apiClient/rutes/prestadores";
import { getPrestadores, getEspecialidades } from "../../apiClient/rutes/catalogos";
import dayjs from "dayjs";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";

const obtenerFotoPrestador = (prestador = {}) => {
  const posiblesCampos = [
    "foto",
    "Foto",
    "fotoWeb",
    "FotoWeb",
    "imagen",
    "Imagen",
    "imagenWeb",
    "ImagenWeb",
    "fotoBase64",
    "FotoBase64",
    "imagenBase64",
    "ImagenBase64",
  ];

  const foto = posiblesCampos.find(
    (campo) =>
      Object.prototype.hasOwnProperty.call(prestador, campo) &&
      typeof prestador[campo] === "string" &&
      prestador[campo].trim() !== "",
  );

  if (!foto) {
    return "";
  }

  const fotoNormalizada = prestador[foto].trim();
  if (
    fotoNormalizada.startsWith("data:") ||
    fotoNormalizada.startsWith("http://") ||
    fotoNormalizada.startsWith("https://")
  ) {
    return fotoNormalizada;
  }

  return `data:image/jpeg;base64,${fotoNormalizada}`;
};

// Orquestación de negocio: filtra, transforma y compone datos
export const traerPrestadores = async (paciente, horariosPrestadores) => {
  let prestadores = await getPrestadores(paciente.token, paciente.mutual);
  let edad = dayjs(dayjs()).diff(paciente.nacimiento, "year");
  prestadores = prestadores.filter((prestador) => {
    if (prestador.filtroEdad) {
      return prestador.edadDesde <= edad && edad <= prestador.edadHasta;
    } else {
      return true;
    }
  });
  prestadores = await getPrimerosProximosTurnos(paciente.token, prestadores, horariosPrestadores, paciente.mutual);
  return prestadores.map((prestador) => ({
    ...prestador,
    codigo: `${prestador.codigo}-${prestador.mutual}`,
    text: prestador.nombre,
    imageSrc: obtenerFotoPrestador(prestador),
    proximoTurnoFecha: prestador.note, // fecha ISO real
    note: prestador.note
      ? `Proximo turno: ${obtenerNombreDia(dayjs(prestador.note).format("dddd"))} ${dayjs(prestador.note).format("DD")} de ${dayjs(prestador.note).format("MMMM, YYYY")}`
      : '',
  }));
};

export const traerPrestadoresParticulares = async (paciente, horariosPrestadores) => {
  let prestadores = await getPrestadores(paciente.token, 1);
  prestadores = prestadores.filter(prestador => prestador.vigente === true);
  prestadores = await getPrimerosProximosTurnos(paciente.token, prestadores, horariosPrestadores, 1);
  return prestadores.map((prestador) => ({
    ...prestador,
    codigo: `${prestador.codigo}-${prestador.mutual}`,
    text: prestador.nombre,
    imageSrc: obtenerFotoPrestador(prestador),
    proximoTurnoFecha: prestador.note, // fecha ISO real
    note: prestador.note
      ? `Proximo turno: ${obtenerNombreDia(dayjs(prestador.note).format("dddd"))} ${dayjs(prestador.note).format("DD")} de ${dayjs(prestador.note).format("MMMM, YYYY")}`
      : '',
  }));
};

export const traerEspecialidades = async (paciente, prestadoresDisponibles) => {
  let especialidades = await getEspecialidades(paciente.token);
  // Aquí puedes filtrar especialidades según prestadoresDisponibles si es necesario
  return especialidades.map((especialidad) => ({
    ...especialidad,
    text: especialidad.nombre,
  }));
};
